import Components from "../../components";

const Login = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Giriş Yap"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Login
        id="login"
        label="Login"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Login;
